import {Stack} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {StyledLine, StyledListItem, StyledUnOrderList} from './styles';
import {LINK_GNDI} from './constants';

const {modalCardGndi} = translations['pt-br'].publicFlow.termsOfUse;

function GndiTerms() {
	return (
		<Stack>
			<StyledLine $bold $noMargin>
				{modalCardGndi.section1.title}
			</StyledLine>
			{Object.values(modalCardGndi.section1.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section2.title}
			</StyledLine>
			{Object.values(modalCardGndi.section2.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section3.title}
			</StyledLine>
			{Object.values(modalCardGndi.section3.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section4.title}
			</StyledLine>
			{Object.values(modalCardGndi.section4.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section5.title}
			</StyledLine>
			{Object.values(modalCardGndi.section5.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section6.title}
			</StyledLine>
			{Object.values(modalCardGndi.section6.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section7.title}
			</StyledLine>
			{Object.values(modalCardGndi.section7.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section8.title}
			</StyledLine>
			{Object.values(modalCardGndi.section8.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section9.title}
			</StyledLine>
			{Object.values(modalCardGndi.section9.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section10.title}
			</StyledLine>
			{Object.values(modalCardGndi.section10.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<StyledLine>
				{modalCardGndi.section10.item14.part1}
				<a href={LINK_GNDI}>{modalCardGndi.section10.item14.part2}</a>
				{modalCardGndi.section10.item14.part3}
			</StyledLine>
			<StyledLine $bold $noMargin>
				{modalCardGndi.section11.title}
			</StyledLine>
			{Object.values(modalCardGndi.section11.items1).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<StyledUnOrderList $noMargin>
				{Object.values(modalCardGndi.section11.list).map(item => (
					<StyledListItem key={item}>{item}</StyledListItem>
				))}
			</StyledUnOrderList>
			{Object.values(modalCardGndi.section11.items2).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section12.title}
			</StyledLine>
			{Object.values(modalCardGndi.section12.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section13.title}
			</StyledLine>
			{Object.values(modalCardGndi.section13.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
			<br />
			<StyledLine $bold $noMargin>
				{modalCardGndi.section14.title}
			</StyledLine>
			{Object.values(modalCardGndi.section14.items).map(item => (
				<StyledLine key={item} $noMargin>
					{item}
				</StyledLine>
			))}
		</Stack>
	);
}

export default GndiTerms;
